import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { environment } from 'src/environments/environment';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
@Injectable({
  providedIn: 'root'
})
export class NotaVentaService {

  private headers = new HttpHeaders()
    .set('Content-Type', 'application/json')

  constructor(private http: HttpClient,
    private gqlclient: GraphQLClient
    ) {
  }

  AgregarProducto(payload: any) {
    return this.http.post(`${environment.API_REST_URL}/document/details/create`,
      payload,
      { headers: this.headers });
  }

  AgregarProductoDeNotaEsp(payload: any) {
    return this.http.post(`${environment.API_REST_URL}/document/details/createNotaEsp`,
      payload,
      { headers: this.headers });
  }

  AplicarDescuentoGlobal(proceso: number, tipoDocumentoDTE: number, payload: any) {
    return this.http.post(
      `${environment.API_REST_URL}/document/update-global-discount?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}`,
      payload,
      {
        headers: this.headers,
      }
    );
  }

  EliminarProducto(proceso: number, ptipo_dte_codigo: number, linea: number) {
    // let httpParams = new HttpParams()
    //   .set('proceso', proceso)
    //   .set('ptipo_dte_codigo', ptipo_dte_codigo)
    //   .set('linea', linea)
    return this.http.post(`${environment.API_REST_URL}/document/details/delete/?proceso=${proceso}&ptipo_dte_codigo=${ptipo_dte_codigo}&linea=${linea}`, {
      headers: this.headers,
      // params: httpParams
    });
  }

  EliminarProductoDelEdit(proceso: number, folio: number,ptipo_dte_codigo: number, linea: number) {
    return this.http.post(`${environment.API_REST_URL}/document/details/deleteprocess/?proceso=${proceso}&folio=${folio}&ptipo_dte_codigo=${ptipo_dte_codigo}&linea=${linea}`, {
      headers: this.headers,
    });
  }

  GuardarProceso(proceso: number, tipoDocumentoDTE: number) {
    // let httpParams = new HttpParams()
    //   .set('proceso', proceso)
    //   .set('tipoDocumentoDTE', tipoDocumentoDTE)
    return this.http.post(
      `${environment.API_REST_URL}/document/create?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}`,
      {},
      { headers: this.headers }
    );
  }


  UpdateProceso(proceso: number, tipoDocumentoDTE: number, folio: number, payload:any) {
    // let httpParams = new HttpParams()
    //   .set('proceso', proceso)
    //   .set('tipoDocumentoDTE', tipoDocumentoDTE)
    return this.http.post(
      `${environment.API_REST_URL}/document/update?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}&folio=${folio}`,
      payload,
      { headers: this.headers }
    );
  }

  eliminarNotaVenta(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: procesoInputType) {
          proceso {
            eliminar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo

              }

            }

          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.proceso.eliminar
        callback({ mensajes, respuesta })
      }
    );
  }

  ObtenerDataEspNotaVenta(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: procesoInputType) {
          proceso {
            obtenerSegunFolio(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                tipo
                texto
                __typename
              }
              respuesta {
                  folio
                  documento
                __typename
              }
              __typename
            }
            __typename
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.proceso.obtenerSegunFolio
        callback({ mensajes, respuesta })
      }
    );
  }

}
